<template>
  <a-page-header
    v-if="display"
    style="border: 1px solid rgb(235, 237, 240);background: #ffffff"
    :title="title"
    :breadcrumb="{ props: { routes } }"
    sub-title=""
  />
</template>

<script>
export default {
  name: 'PageHeader',
  data() {
    return {
      title: '',
      display: true,
      routes: [],
    };
  },
  watch: {
    $route(val) {
      this.routes = val.matched.map(x => ({
        path: x.path,
        breadcrumbName: x.path ? (this.$t(x.meta.code) || x.meta.title) : (this.$t('HOME') || '首页'),
      }));
      this.title = this.$t(val.meta.code) || val.meta.title;
      this.display = val.meta.displayPageHeader;
    },
  },
  created() {
    this.routes = this.$route.matched.map(x => ({
      path: x.path,
      breadcrumbName: x.path ? (this.$t(x.meta.code) || x.meta.title) : (this.$t('HOME') || '首页'),
    }));
    this.title = this.$t(this.$route.meta.code) || this.$route.meta.title;
    this.display = this.$route.meta.displayPageHeader;
  },
};
</script>
